import React from "react";
import { Checkbox } from "../../../Checkbox";
import FormInputWrapper from "../FormInputWrapper";
import { type ControlledCheckboxInputProps } from "./types";

const ControlledCheckboxInput = (props: ControlledCheckboxInputProps) => (
  <FormInputWrapper
    {...props}
    as={Checkbox}
  />
);

export default ControlledCheckboxInput;
